// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedStaffTeam {
  corporateSales: {"enum_constant":"corporateSales"};
  engooInternationalCustomerSupport: {"enum_constant":"engooInternationalCustomerSupport"};
  japanCustomerSupport: {"enum_constant":"japanCustomerSupport"};
  koreaCustomerSupport: {"enum_constant":"koreaCustomerSupport"};
  materials: {"enum_constant":"materials"};
  phDev: {"enum_constant":"phDev"};
  recruitment: {"enum_constant":"recruitment"};
  taiwanCustomerSupport: {"enum_constant":"taiwanCustomerSupport"};
  testing: {"enum_constant":"testing"};
  thailandCustomerSupport: {"enum_constant":"thailandCustomerSupport"};
  tokyoDev: {"enum_constant":"tokyoDev"};
  tutorPayroll: {"enum_constant":"tutorPayroll"};
  tutorSupport: {"enum_constant":"tutorSupport"};
}

export type StaffTeamId = keyof IParsedStaffTeam;
export type StaffTeamData = IParsedStaffTeam[StaffTeamId];
const data: StaffTeamData[] = [{"enum_constant":"corporateSales"},{"enum_constant":"engooInternationalCustomerSupport"},{"enum_constant":"japanCustomerSupport"},{"enum_constant":"koreaCustomerSupport"},{"enum_constant":"materials"},{"enum_constant":"phDev"},{"enum_constant":"recruitment"},{"enum_constant":"taiwanCustomerSupport"},{"enum_constant":"testing"},{"enum_constant":"thailandCustomerSupport"},{"enum_constant":"tokyoDev"},{"enum_constant":"tutorPayroll"},{"enum_constant":"tutorSupport"}];
export default data;
